import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import Header from '../layouts/Header';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
// import ChatIcon from '@material-ui/icons/Chat';
// import MailIcon from '@material-ui/icons/Mail';
// import CallIcon from '@material-ui/icons/Call';
import CssBaseline from '@material-ui/core/CssBaseline';

export interface ContactPageViewProps {

}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: '100vh',
            backgroundColor: '#eeeeee',
        },
        gridHight: {
            height: '93vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: '#eeeeee',
            overflow: 'auto'
            // background: 'linear-gradient(rgba(255,255,255,.7), rgba(255,255,255,.7)),url(/assets/svg/mail.svg)',
        },
        card: {
            alignContent: 'center',
            height: '100%',
            width: '100%',
            minWidth: '30%',
            backgroundColor: '#FFFFFF',
            borderRadius: '5%'

        },
        paper: {
            margin: theme.spacing(6, 4),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: 'none',
            backgroundColor: 'transparent'
        },
        font: {
            fontWeight: 700,
            fontSize: '27px',
            color: '#303F9F',
        },
        typographyCard: {
            color: 'rgb(48, 63, 159)',
            textAlign: 'center'
        },
        typography: {
            textAlign: 'center',
            color: '#303F9F',
            fontWeight: 900,
            margin: '0 25%',
            fontSize: '35px'
        },
    })
);

const ContactPageView: React.StatelessComponent<ContactPageViewProps> = props => {
    const classes = useStyles({});

    return (
        <div className={classes.root}>
            <Header />
            <CssBaseline />
            <Grid component="main" className={classes.gridHight}>
                <Typography component="h3" variant="h3" className={classes.typography}>
                    CONTACT US
                </Typography>
                <div className={classes.paper}>
                    <Grid container item xs={12} spacing={4}>
                        <Grid item xs={12} sm={4}>
                            <Card className={classes.card}>
                                <Paper className={classes.paper}>
                                    <img src="/assets/svg/mail.svg" width="200px" height="200px" />
                                    <Typography component="div" className={classes.typographyCard}>
                                        <span className={classes.font}>Email Us</span><br /> info@easydentdesigns.com
                                    </Typography>
                                </Paper>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Card className={classes.card}>
                                <Paper className={classes.paper}>
                                    <img src="/assets/svg/support.svg" width="200px" height="200px" />
                                    <Typography component="div" className={classes.typographyCard}>
                                        <span className={classes.font}>Raise a support ticket</span><br />Login Required
                                    </Typography>
                                </Paper>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Card className={classes.card}>
                                <Paper className={classes.paper}>
                                    <img src="/assets/svg/call.svg" width="200px" height="200px" />
                                    <Typography component="div" className={classes.typographyCard}>
                                        <span className={classes.font}>Call Us</span> <br /> +91 124 4888031 <b>|</b> +91 124 4888045
                                    </Typography>
                                </Paper>
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        </div >
    );
};

export default ContactPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/ContactUsView.tsx